import React from 'react';
import { GeneralSettings } from '@/components/admin/GeneralSettings';

/**
 * Step 1 — General Settings (TYPE A: Recommended Configuration)
 *
 * Embeds the real GeneralSettings page directly.
 * All changes are immediately persisted.
 * No empty state — page shown directly (Type A).
 */
export const StepGeneralSettings: React.FC = () => {
  return (
    <div className="p-6 h-full">
      <div className="rounded-lg border border-border bg-white overflow-auto max-h-[calc(100vh-200px)]">
        <GeneralSettings />
      </div>
    </div>
  );
};
